import React, { useState, useEffect } from 'react';

import Footer from '../common/Footer';
import { scrollHandler, goToByScroll } from '../../util/animation';
import Header from '../common/Header';
import { history } from '../../history/history';
import useModel from '../admin/common/useModel';
import Model from '../admin/common/stationPopup';

import AOS from 'aos';

const About = props => {

    const { isShowing, toggle } = useModel();
    const [goToTop, handleGoToTop] = useState(true);

    const openPopup = () => {
        document.body.classList.add('hide_overflow');
        toggle();
    }

    //Initialize the function to scroll.
    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('scroll', scrollHandler);
        handleGoToTop(false);
        AOS.init({
            duration: 600,
        });
        return () => {
            window.removeEventListener('scroll', scrollHandler)
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (goToTop) {
                window.scrollTo(0, 0);
            }
        }, 300);
    });

    //Return the home content.
    return (
        <div>
            <div className="main_wrapper">

                <div className="about_banner">
                    <Header active={true} withoutSticky={true} />
                    {/* <div className="about_logo" onClick={()=>{history.push('/')}}>
                        <div><img src="../../assets/images/new_logo.png" /></div>
                    </div> */}
                    <div className="about_inner_wrapper">
                        <div className="largest_radio">One of India’s Largest Radio Network With</div>
                        <div className="about_card_wrapper" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                            <div className="about_card_inner">
                                <div className="about_card_img"> <img src="../../assets/images/ic_station.png" /></div>
                                <div className="about_card_text" onClick={openPopup}>
                                    <span className="card_numb" >58</span>
                                    <span className="numb_desc">STATIONS</span>
                                </div>
                            </div>
                            <div className="about_card_inner">
                                <div className="about_card_img"> <img src="../../assets/images/ic_town.png" /></div>
                                <div className="about_card_text">
                                    <span className="card_numb">1900+</span>
                                    <span className="numb_desc">TOWNS</span>
                                </div>
                            </div>
                            <div className="about_card_inner">
                                <div className="about_card_img"> <img src="../../assets/images/ic_villages.png" /></div>
                                <div className="about_card_text">
                                    <span className="card_numb">1.2 Lakhs+</span>
                                    <span className="numb_desc">VILLAGES</span>
                                </div>
                            </div>
                            <div className="about_card_inner">
                                <div className="about_card_img"> <img src="../../assets/images/ic_listeners.png" /></div>
                                <div className="about_card_text">
                                    <span className="card_numb">34 Crores+</span>
                                    <span className="numb_desc">LISTENERS</span>
                                </div>
                            </div>
                        </div>
                        <div className="aboutBanner_para">
                            BIG FM has amplified the power of radio as a medium to entertain
                            by going beyond the metros to virgin markets and offering unique experience
                            and reach to consumers and advertisers, respectively. Within a short span of time,
                            the network with its distinctive content and innovative promotions have established
                            itself as a leader in the FM space. The network’s occasion based programming, CSR
                            Activities and client integrated campaigns strongly reflects its Dhun Badalke toh
                            Dekho ethos. The original content based shows and engaging brand led campaigns has
                            consistently won accolades at prestigious industry awards like the EMVIES, ABBYs,
                            Asian Customer Engagement Awards, Indian Radio Forum &amp; New York Festival.
          </div></div>
                    <div className="philosophy_scroll"><a onClick={goToByScroll.bind(this, 'scrolltophilosophy')}>
                        <img className="home_scroll about_scroll " src="../../assets/images/scroll_icon.png" />Our Philosophy</a></div>
                </div>
                <div className="philosophy_container" id="scrolltophilosophy">
                    <h2 className="philosophy_header">Our Philosophy</h2>
                    <div className="philosophy">
                        <div className="philosophy_left">
                            <div className="philosophy_desc">
                                BIG FM has amplified the power of radio as a medium to entertain by going
                                beyond the metros to virgin markets and offering unique experience and reach
                                to consumers and advertisers, respectively. Within a short span of time, the
                                network with its distinctive content and innovative promotions have established
                                itself as a leader in the FM space. The network’s occasion based programming, CSR
                                Activities and client integrated campaigns strongly reflects its Dhun Badalke toh
                                Dekho ethos. The original content based shows and engaging brand led campaigns has
                                consistently won accolades at prestigious industry awards like the EMVIES, ABBYs,
                                Asian Customer Engagement Awards, Indian Radio Forum &amp; New York Festival.
            </div>
                        </div>
                        <div className="philosophy_right" data-aos="zoom-in">
                            <img src="../../assets/images/about_bigfm_infographic.png" />
                        </div>
                    </div>
                </div>
                <Footer />

            </div>
            <Model
                isShowing={isShowing}
                hide={toggle}
            />
        </div>
    );

}

export default About;


// WEBPACK FOOTER //
// ./web/components/about/About.jsx